import {Button} from '@superweb/ui'
import {Typography} from '@yandex-delivery/ui'
import React from 'react'

import {getAssetUrl} from '../../utils'
import errorPng from './assets/error.svg'
import styleClasses from './classes.module.css'
import {useScreenParams} from './hooks'

export type ErrorScreenProps = {
  text?: string
  buttonProps?: ButtonProps
}

export type ButtonProps = {
  text?: string
  view?: React.ComponentProps<typeof Button>['view']
  action?: VoidFunction
}

export function ErrorScreen({text, buttonProps}: ErrorScreenProps) {
  const {action, buttonText, errorText, view} = useScreenParams({buttonProps, text})

  return (
    <div className={styleClasses.screen}>
      <img alt="error" src={getAssetUrl(errorPng)} />
      <Typography density="normal" level="body1" weight="medium">
        {errorText}
      </Typography>
      <Button onPress={action} text={buttonText} view={view} />
    </div>
  )
}
